
const keyPrefix = "metabolome_16s_"
export const saveDataToSessionStorage = (key, value) => {
  sessionStorage.setItem(AddFix(key), value)
}

export const getDataInSessionStorage = (key) => {
  var value = sessionStorage.getItem(AddFix(key))
  return value
}
export const removeDataInSessionStorage = (key) => {
  // if (!key) {
  //   return ''
  // }
  sessionStorage.removeItem(AddFix(key))
  // if (!value) {
  //   return ''
  // }
}
export const AddFix = (value) => {
  value = keyPrefix + value
  return value

}
